import { render, staticRenderFns } from "./PreviewFileUploadAttribute.vue?vue&type=template&id=14342c24&scoped=true"
import script from "./PreviewFileUploadAttribute.vue?vue&type=script&lang=js"
export * from "./PreviewFileUploadAttribute.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14342c24",
  null
  
)

export default component.exports